import gql from 'graphql-tag';
import { SalesActionInteractionMetadata } from '../../definitions/schemas';
import { InteractionEvent } from '../../enums/InteractionEvent';
import Interface from '../Interface';

interface TrackInteractionInput {
  roomId: string;
  event: InteractionEvent;
  measure: number;
  metadata?: SalesActionInteractionMetadata;
}

export default class TrackInteractionInterface extends Interface {
  public async trackInteraction(input: TrackInteractionInput) {
    return this.mutate<null>(async () => {
      const response = await this.apolloService.executeMutation({
        mutation: gql`
          mutation trackInteraction($input: TrackInteractionInput!) {
            trackInteraction(input: $input) {
              errors
            }
          }
        `,
        variables: {
          input,
        },
      });

      const { errors, message } = response.data.trackInteraction;

      return {
        data: null,
        serverErrors: errors,
        serverMessage: message,
      };
    }, 'Error tracking an interaction event');
  }
}
